import { Link } from 'react-router-dom';
import { PersonIllustration } from '../../../../constants/svg';
import styles from './TalentsHero.module.css';

/* ── Floating card data ──────────────────────────────────── */
const jobMatches = [
  { logo: 'PS', logoClass: 'l1', title: 'Product Designer', company: 'Paystack · Remote',      pct: '96%' },
  { logo: 'FL', logoClass: 'l2', title: 'UX Lead',          company: 'Flutterwave · Hybrid',   pct: '91%' },
  { logo: 'AN', logoClass: 'l3', title: 'Senior Designer',  company: 'Andela · Remote',         pct: '88%' },
];

const strengths = [
  { label: 'Problem-solving', pct: '92%' },
  { label: 'Communication',   pct: '88%' },
  { label: 'Creativity',      pct: '84%' },
];

/* ── Illustrated person SVG ─────────────────────────────── */
// function PersonIllustration() {
//   return (
 
//   );
// }

/* ── Component ───────────────────────────────────────────── */
export default function TalentsHero() {
  return (
    <header className={styles.hero}>
      <div className={`${styles.container} ${styles.heroGrid}`}>

        {/* ── Left: text ── */}
        <div className={styles.textCol}>
          <span className={styles.eyebrow}>
            <span className={styles.dot} />
            Built for Africa's next generation of talent
          </span>

          <h1 className={styles.heroTitle}>
            You're not underqualified.<br />
            You're just <span className={styles.accent}>overlooked.</span>
          </h1>

          <p className={styles.heroSub}>
            Stand out with AI-powered insights, verified skills, and get matched to real
            opportunities — built for ambitious young professionals across Africa.
          </p>

          <div className={styles.heroActions}>
            <Link to="/register?tab=talent" className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}>
              Get Started — it's free
            </Link>
            <Link to="/login" className={`${styles.btn} ${styles.btnSecondary} ${styles.btnLg}`}>
              Take Assessment
            </Link>
          </div>

          {/* <div className={styles.heroTrust}>
            <div className={styles.avatarStack}>
              <span className={styles.av1}>A</span>
              <span className={styles.av2}>M</span>
              <span className={styles.av3}>K</span>
              <span className={styles.av4}>+</span>
            </div>
            <span>
              <b className={styles.trustBold}>12,000+</b> talents already discovered
            </span>
          </div> */}
        </div>

        {/* ── Right: visual ── */}
        <div className={styles.heroVisual}>

          {/* Person card */}
          <div className={styles.personCard}>
            <PersonIllustration className={styles.personSvg} />
            <div className={styles.personOverlay}>
              <div>
                <div className={styles.personName}>Adaeze Okonkwo</div>
                <div className={styles.personRole}>Product Designer · Lagos</div>
              </div>
              <span className={styles.personBadge}>94% Match</span>
            </div>
          </div>

          {/* Float 1 — AI Talent Score */}
          <div className={`${styles.floatCard} ${styles.float1}`}>
            <div className={styles.cardTitle}>AI Talent Score</div>
            <div className={styles.score}>
              <b>87</b>
              <span>↑ 12 this week</span>
            </div>
            <div className={styles.bar}>
              <i style={{ width: '87%' }} />
            </div>
          </div>

          {/* Float 2 — Top Job Matches */}
          <div className={`${styles.floatCard} ${styles.float2}`}>
            <div className={styles.cardTitle}>Top Job Matches</div>
            {jobMatches.map((m) => (
              <div key={m.title} className={styles.matchRow}>
                <div className={`${styles.matchLogo} ${styles[m.logoClass]}`}>{m.logo}</div>
                <div className={styles.matchText}>
                  {m.title}
                  <small>{m.company}</small>
                </div>
                <div className={styles.matchPct}>{m.pct}</div>
              </div>
            ))}
          </div>

          {/* Float 3 — Top Strengths (hidden on mobile) */}
          <div className={`${styles.floatCard} ${styles.float3}`}>
            <div className={styles.cardTitle}>Top Strengths</div>
            {strengths.map((s) => (
              <div key={s.label} className={styles.skillRow}>
                <em>{s.label}</em>
                <span className={styles.pct}>{s.pct}</span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </header>
  );
}